import { render, staticRenderFns } from "./FirstModal.vue?vue&type=template&id=51bbc7d0&scoped=true"
import script from "./FirstModal.vue?vue&type=script&lang=js"
export * from "./FirstModal.vue?vue&type=script&lang=js"
import style0 from "./FirstModal.vue?vue&type=style&index=0&id=51bbc7d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bbc7d0",
  null
  
)

export default component.exports